import { DropdownGroupItem, FormatCompanyPeopleOptionsParams } from '../types';

export default function formatCompanyPeopleOptions({
  people,
  companies,
  hidePeople = false,
  hideCompanies = false
}: FormatCompanyPeopleOptionsParams): DropdownGroupItem[] {
  return [
    !hidePeople
      ? {
          key: 'people-label',
          label: hideCompanies ? '' : 'PEOPLE',
          type: 'People',
          items:
            people.length > 0
              ? people.map(person => {
                  return {
                    key: person.id,
                    label: person.name,
                    value: { ...person, type: 'People' }
                  };
                })
              : [
                  {
                    key: 'empty-people',
                    label: 'empty',
                    type: 'People'
                  }
                ]
        }
      : {},
    !hideCompanies
      ? {
          key: 'company-label',
          label: hidePeople ? '' : 'COMPANIES',
          type: 'Company',
          items:
            companies.length > 0
              ? companies.map(company => {
                  return {
                    key: company.id,
                    label: company.name,
                    value: { ...company, type: 'Company' }
                  };
                })
              : [
                  {
                    key: 'empty-company',
                    label: 'empty',
                    type: 'Company'
                  }
                ]
        }
      : {}
  ].filter(item => Object.keys(item).length > 0) as DropdownGroupItem[];
}
